// Values accepted by the `sumsubReviewStatus` filter on /user/search and
// /user/csv/search. Deliberately narrower than the field itself can hold —
// `init` and `queued` are not filterable, matching how kycStatus omits `new`.
export const SUMSUB_REVIEW_FILTER_STATUSES = [
  'any',
  'pending',
  'completed',
  'rejected',
];

export const SUMSUB_REVIEW_STATUS_LABELS: Record<string, string> = {
  any: 'All',
  pending: 'Pending',
  completed: 'Passed',
  rejected: 'Failed',
};

// `sumsubReviewStatus` is not an enum server side — Sumsub adds statuses over
// time and an unknown one is stored verbatim, so anything unrecognised is
// treated as still in progress rather than dropped.
export function getSumsubReviewStatusLabel(status?: string): string {
  if (!status) {
    return 'Not started';
  }

  switch (status) {
    case 'completed':
      return 'Passed';
    case 'rejected':
      return 'Failed';
    default:
      return 'In progress';
  }
}

export function getSumsubReviewStatusColor(status?: string): string {
  switch (status) {
    case 'completed':
      return 'success';
    case 'rejected':
      return 'error';
    default:
      return 'default';
  }
}

// Only set on a RED verdict: RETRY means the client may resubmit, FINAL means
// they may not.
export function getSumsubRejectSuffix(rejectType?: string): string {
  return rejectType === 'RETRY' ? ' · can retry' : '';
}
